$(document).ready(function() {
    // Prevent Enter key from closing the dropdown
    $('.js-search-designer, .js-enterable.checkbox__input').keydown(function(event) {
        if (event.keyCode === 13) { // Enter key
            event.preventDefault(); // Prevent default action (form submission)
            event.stopPropagation(); // Stop the event from propagating
        }
    });

    // Initialize the selected designers from the URL
    let selectedDesigners = getSelectedDesignersFromUrl();
    selectedDesigners.forEach(designer => {
        $(`.js-enterable.checkbox__input[value="${designer}"]`).prop('checked', true);
    });
    updateSelectedDesignersUI(selectedDesigners);

    // Designer Filter Search and Selection
    $('.js-search-designer').keyup(function() {
        // Add/remove class to list parent based on input value
        let $input = $(this);
        let $list = $('.filters__designer-list');
        let isABTest920 = $input.data('ab920');
        console.log(isABTest920);
        if(isABTest920){
            if ($input.val().trim() !== '') {
                $list.addClass('has-value');
            } else {
                $list.removeClass('has-value');
            } 
        }

        // Directly use the user's input for the search, including symbols.
        // We escape special regex characters to prevent unexpected behavior.
        let value = $(this).val().replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');

        let numOfVisibleResults = 0;

        $('.filters__designer-list li').each(function() {
            let span = $(this).find('span');
            let originalText = span.text();
            // RegExp object for case-insensitive matching
            let regex = new RegExp(value, 'gi');

            if (originalText.search(regex) > -1) {
                // Replace the matched text with a bold version for highlighting
                let boldedText = originalText.replace(regex, function(match) {
                    return '<strong>' + match + '</strong>';
                });
                span.html(boldedText);
                $(this).removeClass('u-hide');
                numOfVisibleResults++;
            } else {
                // If there's no match, simply show the original text without any modification
                span.html(originalText);
                $(this).addClass('u-hide');
                
            }
        });

        if (numOfVisibleResults > 0) {
            $('.js-filter-search-no-results').hide().empty();
        } else {
            $('.js-filter-search-no-results').html('No results found.').show();
        }
    });

    $('.js-enterable.checkbox__input').change(function() {
        let selectedDesigners = [];
        $('.js-enterable.checkbox__input:checked').each(function() {
            selectedDesigners.push($(this).val());
        });

        updateSelectedDesignersUI(selectedDesigners);
        updateUrlParameters(selectedDesigners);
    });

    $(document).on('click', '.js-filter-button', function() {
        let designerId = $(this).data('designer-id');
        $(`.js-enterable.checkbox__input[value="${designerId}"]`).prop('checked', false).trigger('change');
    });

    // Function to focus on the previous button
    function focusOnPreviousButton() {
        // Get the previous button element
        let previousButton = $('.selected-designers .js-filter-button:last');

        // Check if a previous button exists
        if (previousButton.length > 0 ) {
            // Set focus on the previous button
            previousButton[0].focus();
        }
    }

    // Function to handle keydown event
    function handleKeydown(event) {
        if (event.keyCode === 13 || event.keyCode === 32) {
            let designerId = $(this).find('.js-filter-button').data('designer-id');
            $(`.js-enterable.checkbox__input[value="${designerId}"]`).prop('checked', false).trigger('change');

            focusOnPreviousButton();
            return false; // Prevent default action
        }
    }

    // Attach keydown event listener to dynamically inserted buttons
    $('.selected-designers').on('keydown', '.js-filter-button', handleKeydown);
});

function getUrlParameter(name) {
    let results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    return results === null ? null : decodeURIComponent(results[1]) || null;
}

function getSelectedDesignersFromUrl() {
    let designers = [];
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.forEach((value, key) => {
        if (key === 'designer') {
            designers.push(value);
        }
    });
    return designers;
}

function updateUrlParameters(designers) {
    let url = new URL(window.location.href);
    url.searchParams.delete('designer');
    designers.forEach(designer => {
        url.searchParams.append('designer', designer);
    });
    window.history.pushState({}, '', url);
}

function updateSelectedDesignersUI(selectedDesigners) {
    let designerButtons = selectedDesigners.map(designer => `
        <button 
            data-designer-id="${designer}"
            class="pill-button pill-button--light-grey u-margin-r--lg u-margin-b--lg js-filter-button">
            <span class="u-screen-reader">Remove </span>${designer}<span class="u-screen-reader"> from filter </span>
            <span class="u-pointer icon icon--x icon--xs u-margin-l--sm js-filter-button" data-designer-id="${designer}">
                <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
                    <path d="M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28
                        4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8
                        9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z">
                    </path>
                </svg>
            </span>
        </button>
    `).join('');

    if (selectedDesigners.length > 0) {
        $('.selected-designers').html(designerButtons);
    } else {
        $('.selected-designers').html('');
    }
}


// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/filter-search.js